import { PageEvent } from '@spartacus/storefront'

export class MouseFlowEvent extends PageEvent {

  static readonly type = 'MouseFlowEvent'

  mouseFlow?: Record<string, any>
}

